module.exports = __webpack_public_path__ + "img/desktop-preview.1b35d4fb.jpg";